import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WorkflowBlock } from 'dashboard/models/workflow-block';

export type BlockData = Pick<WorkflowBlock['attributes'], 'outputs' | 'description'>;

export interface WorkflowBlockState {
  blockData: BlockData;
}

export const initialState: WorkflowBlockState = {
  blockData: {
    description: '',
    outputs: [],
  },
};

const { reducer, actions } = createSlice({
  name: 'workflow-block',
  initialState,
  reducers: {
    clearBlockData: () => {
      return initialState;
    },
    setBlockData: (state, action: PayloadAction<Partial<BlockData>>) => {
      state.blockData = {
        ...state.blockData,
        ...action.payload,
      };
    },
  },
});

export const { clearBlockData, setBlockData } = actions;

export const workflowBlockReducer = reducer;
